import React from 'react';

const ReleaseMgt = () => (
  <div>
    <h2>Release Management</h2>
    <p>Manage project releases and versions here.</p>
  </div>
);

export default ReleaseMgt;